<template>
	<div class="list">
		<div v-for="(item,index) in list" :key="index" class="listDiv" @click="$router.push('/details?id='+item.fid)" v-if="!listContent">
			<h3 class="ellipsis">{{item.name}}</h3>
			<p>{{gshTime(item.uploadtime)}}</p>
			
		</div>
		<div class="listContent" v-if="listContent">
			<img src="../assets/img/kong.png" />
			<p>您尚未上传电子证据。</p>
		</div>
		<div class="bottom">
			<p>由司法电子证据云平台提供电子证据认证服务</p>
			<p>客服电话:010-60608644 工作日（9:00~18:00）</p>
		</div>
		<!--数据加载中-->
		<div class="certification" v-show="loding">
			<img src="../assets/img/icon.png" alt="">
			<p>数据加载中…</p>
		</div>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				list: [],
				listContent: false,
				userids: "",
				loding: true
			}
		},
		// 父组件传过来的值
		props: [],
		components: {

		},
		watch: {
			//			'userids':function(){
			//				this.listFun();
			//			}
		},
		computed: {

		},
		created() {
			document.title = "证据列表";
			this.userids = sessionStorage.userid;
			this.authcode = this.$route.query.authcode;
			this.appkey = this.$route.query.appkey;
			sessionStorage.setItem("authcode", this.authcode);
			sessionStorage.setItem("appkey", this.appkey);
			this.getUserInfo();
			//统计
			this.tj(this.appkey,this.$route.path)
		},
		mounted() {
			//			this.listFun();
		},
		// 组件销毁后
		destroyed: function() {

		},
		methods: {
			getUserInfo: function() {
				let self = this;
				this.$axios
					.post("/v2/getMemberInfo", {
						appkey: this.appkey,
						authcode: sessionStorage.authcode
					})
					.then(function(res) {
						if(res.data.code == 2001) {
							sessionStorage.setItem("userid", res.data.data.userid);
							sessionStorage.setItem("token", res.data.data.token);
							self.listFun();
						}
					})
					.catch(function(err) {
						console.log(err);
					});
			},
			listFun: function() {
				//				console.log(4444444444);
				//				console.log(sessionStorage.userid, 2222222);
				let self = this;
				this.$axios.post('/v2/evidenceList', {
					userid: sessionStorage.userid,
					token: sessionStorage.token,
					appkey: sessionStorage.appkey,
					sign: $.md5(sessionStorage.token + sessionStorage.appkey + self.appsecret)
				}).then(function(res) {
					// console.log(res.data);
					if(res.data.code == 2001) {
						if(res.data.data == '') {
							self.listContent = true
						}
						self.list = res.data.data;
						self.loding = false
						// console.log(res.data.data);
					}
				}).catch(function(err) {
					console.log(err);
				});
			},
			gshTime(time) {
				// console.log()
				var time = new Date(parseInt(time) * 1000);
				var y = time.getFullYear(); //年
				var m = time.getMonth() + 1; //月
				var d = time.getDate(); //日
				var h = time.getHours(); //时
				var mm = time.getMinutes(); //分
				var s = time.getSeconds(); //秒
				return y + "-" + m + "-" + d + " " + h + ":"+ mm + ":"+ s;
			}
		},
		watch: {

		}
	}
</script>
<style scoped lang="less">
	.list {
		overflow: hidden;
		min-height: 100vh;
		background: #f7f9fa;
		width: 100%;
		position: relative;
		padding-bottom: 75px;
		box-sizing: border-box;
		.listDiv {
			background: #FFFFFF;
			border: 1px solid #EAEAEA;
			border-radius: 5px;
			width: 93.6%;
			padding: 20px 36px 20px 15px;
			box-sizing: border-box;
			margin: 12px auto 0px auto;
			position: relative;
			&::after {
				position: absolute;
				right: 9px;
				margin-top: -4px;
				top: 50%;
				content: '';
				display: block;
				border-top: 2px solid #C7C7C7;
				border-right: 2px solid #C7C7C7;
				width: 8px;
				height: 8px;
				transform: rotate(45deg);
			}
			h3 {
				font-size: 16px;
				color: #333333;
				line-height: 16px;
				margin-bottom: 13px;
			}
			p {
				font-size: 12px;
				color: #999999;
				line-height: 13px;
			}
		}
		.bottom {
			position: absolute;
			bottom: 0;
			left: 0;
			width: 100%;
			p {
				text-align: center;
				&:nth-of-type(1) {
					font-size: 12px;
					color: #8B572A;
				}
				&:nth-of-type(2) {
					font-size: 12px;
					color: #999999;
					margin: 1px 0 20px 0;
				}
			}
		}
		.listContent {
			p {
				width: 100%;
				text-align: center;
				font-size: 12px;
				color: #999999;
				margin-top: 15px;
				padding-left: 11px;
				box-sizing: border-box;
			}
			img {
				display: block;
				margin: 0 auto;
				margin-top: 50%;
			}
		}
		.certification {
			position: absolute;
			width: 100%;
			top: 50%;
			transform: translateY(-50%);
			img {
				width: 67px;
				display: block;
				margin: 0 auto;
			}
			p {
				text-align: center;
				font-size: 12px;
				color: #666666;
				margin-top: 7px;
			}
		}
	}
</style>